import React from 'react';

import { ACCOUNT_ALREADY_CONFIRMED } from 'common/module/ui/lazy-modal/constant-types';
import buildReactDomModalModule from 'common/module/ui/lazy-modal/react-dom-modal-module';
import ReactModal from 'common/module/ui/lazy-modal/react-modal';
import { path } from 'common/tools/network/routing';
import trans from 'common/tools/translations/trans';

const AccountAlreadyConfirmedModal = () => {
  return (
    <ReactModal size="small" className="modal-welcome no-header" title="">
      <p className="vertical-spacing">
        {trans('userspace.account-already-activated')}
      </p>
      <a
        className="button button-inverse-full"
        href={path('homepage', {}, true)}
      >
        {trans('userspace.go-to-homepage')}
      </a>
    </ReactModal>
  );
};

export default buildReactDomModalModule(ACCOUNT_ALREADY_CONFIRMED, () => (
  <AccountAlreadyConfirmedModal />
));
